/** @format **/
import { MvnoOperationSetupCollectionInterface } from '../../interfaces/platform/MvnoOperatorSetup';

export const MnoOperatorSetupAction = {
    MNO_OPERATOR_SET_GET_LIST: 'MNO_OPERATOR_SET_GET_LIST',
};

export type MnoOperatorSetupReducersType = {
    type: string;
    mvnoOperatorSetupList?: MvnoOperationSetupCollectionInterface;
};

export const mnoOperatorSetupReducers = (state: any, params: MnoOperatorSetupReducersType): object => {
    switch (params.type) {
        case MnoOperatorSetupAction.MNO_OPERATOR_SET_GET_LIST:
        default:
            return {
                ...state,
                ...params,
            };
    }
};
